export const spacesNotAllowed = (words) => {
  return words.replace(/\s/g, '');
}

export const sanitizeString = (value) => {
  return value.toString()
      .replace(/[¥Ð¾]/g, 'Ñ')
      .replace('š', 'ü')
      .replace('Š', 'Ü')
      .replace('', 'Ü');
};
